
// These icons are from http://design/icons, in the 'Schema' section.
// Their names are intentionally kept the same as on that page for easy reference.
import { assertNever } from '@tableau/data-structures';
import React from 'react';
import { SvgSchemaViewerBoolCalcDiscrete, SvgSchemaViewerBoolDiscrete, SvgSchemaViewerDateCalcContinuous, SvgSchemaViewerDateCalcDiscrete, SvgSchemaViewerDateContinuous, SvgSchemaViewerDateDiscrete, SvgSchemaViewerDateTimeCalcContinuous, SvgSchemaViewerDateTimeCalcDiscrete, SvgSchemaViewerDateTimeContinuous, SvgSchemaViewerDateTimeDiscrete, SvgSchemaViewerGeoCalcContinuous, SvgSchemaViewerGeoCalcDiscrete, SvgSchemaViewerGeoContinuous, SvgSchemaViewerGeoDiscrete, SvgSchemaViewerGroupDiscrete, SvgSchemaViewerGroupGeoDiscrete, SvgSchemaViewerHierarchy, SvgSchemaViewerMeasuresNumberCalcContinuous, SvgSchemaViewerNumberCalcDiscrete, SvgSchemaViewerNumberContinuous, SvgSchemaViewerNumberDiscrete, SvgSchemaViewerNumericBin, SvgSchemaViewerNumericBinContinuous, SvgSchemaViewerSet, SvgSchemaViewerTextCalcContinuous, SvgSchemaViewerTextCalcDiscrete, SvgSchemaViewerTextContinuous, SvgSchemaViewerTextDiscrete, SvgSchemaViewerUnknown } from '../../../../../../gen-src/icons';
import { FieldIcon } from '../types/FieldIcon';

export function SvgFieldIcon(props: { fieldIcon: FieldIcon | null }): JSX.Element | null {
  if (!props.fieldIcon) {
    return <SvgSchemaViewerUnknown />;
  }
  switch (props.fieldIcon) {

    // Booleans are always discrete
    case FieldIcon.BoolCalc:
      return <SvgSchemaViewerBoolCalcDiscrete />;
    case FieldIcon.Bool:
      return <SvgSchemaViewerBoolDiscrete />;

    case FieldIcon.DateCalcContinuous:
      return <SvgSchemaViewerDateCalcContinuous />;
    case FieldIcon.DateCalcDiscrete:
      return <SvgSchemaViewerDateCalcDiscrete />;
    case FieldIcon.DateContinuous:
      return <SvgSchemaViewerDateContinuous />;
    case FieldIcon.DateDiscrete:
      return <SvgSchemaViewerDateDiscrete />;

    case FieldIcon.DateTimeCalcContinuous:
      return <SvgSchemaViewerDateTimeCalcContinuous />;
    case FieldIcon.DateTimeCalcDiscrete:
      return <SvgSchemaViewerDateTimeCalcDiscrete />;
    case FieldIcon.DateTimeContinuous:
      return <SvgSchemaViewerDateTimeContinuous />;
    case FieldIcon.DateTimeDiscrete:
      return <SvgSchemaViewerDateTimeDiscrete />;

    case FieldIcon.GeoCalcContinuous:
      return <SvgSchemaViewerGeoCalcContinuous />;
    case FieldIcon.GeoCalcDiscrete:
      return <SvgSchemaViewerGeoCalcDiscrete />;
    case FieldIcon.GeoContinuous:
      return <SvgSchemaViewerGeoContinuous />;
    case FieldIcon.GeoDiscrete:
      return <SvgSchemaViewerGeoDiscrete />;

    // Groups are always discrete
    case FieldIcon.Group:
      return <SvgSchemaViewerGroupDiscrete />;
    case FieldIcon.GroupGeo:
      return <SvgSchemaViewerGroupGeoDiscrete />;

    case FieldIcon.Hierarchy:
      return <SvgSchemaViewerHierarchy />;

    case FieldIcon.NumberCalcContinuous:
      return <SvgSchemaViewerMeasuresNumberCalcContinuous />; // This icon has an inconsistent name
    case FieldIcon.NumberCalcDiscrete:
      return <SvgSchemaViewerNumberCalcDiscrete />;
    case FieldIcon.NumberContinuous:
      return <SvgSchemaViewerNumberContinuous />;
    case FieldIcon.NumberDiscrete:
      return <SvgSchemaViewerNumberDiscrete />;

    case FieldIcon.NumericBinContinuous:
      return <SvgSchemaViewerNumericBinContinuous />;
    case FieldIcon.NumericBinDiscrete:
      return <SvgSchemaViewerNumericBin />; // This discrete icon has no suffix (unlike the others)

    case FieldIcon.Set:
      return <SvgSchemaViewerSet />;

    case FieldIcon.TextCalcContinuous:
      return <SvgSchemaViewerTextCalcContinuous />;
    case FieldIcon.TextCalcDiscrete:
      return <SvgSchemaViewerTextCalcDiscrete />;
    case FieldIcon.TextContinuous:
      return <SvgSchemaViewerTextContinuous />;
    case FieldIcon.TextDiscrete:
      return <SvgSchemaViewerTextDiscrete />;

    case FieldIcon.Unknown:
      return <SvgSchemaViewerUnknown />;

    default:
      // This is to cause a compile-time error if a case is missing.
      assertNever(props.fieldIcon);
      return null; // This code is unreachable but requred by the complier.
  }
}
